module.exports = __webpack_public_path__ + "static/img/home_content_4.f805033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/home_content_4.png
// module id = SFsA
// module chunks = 1